import { type ComponentProps, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { setHeaderConfig } from '@/store/app.slice';

import ErrorTemplate from './error-template';

type IProps = {
  shouldCheckMenu?: boolean;
} & Omit<ComponentProps<typeof ErrorTemplate>, 'type'>;

const NotFound: React.FC<IProps> = ({ shouldCheckMenu = true, ...props }) => {
  const dispatch = useAppDispatch();
  const { menu } = useAppSelector((state) => state.userInfo);

  const showNotFound = menu.length !== 0 || !shouldCheckMenu;

  useEffect(() => {
    if (showNotFound) {
      dispatch(
        setHeaderConfig({
          title: '404',
          helmetTitle: '404'
        })
      );

      return () => {
        dispatch(setHeaderConfig({}));
      };
    }
  }, [dispatch, showNotFound]);

  // Не показываем 404 если нет меню
  if (!showNotFound) return null;
  return <ErrorTemplate type="404" {...props} />;
};

export default NotFound;
